function ContentCard({ children }) {
  return <div>{children}</div>;
}

export default ContentCard;
